import {Service, service, inject} from "./di";

import appboy from "@braze/web-sdk";

@service("BrazeSDKService")
export class BrazeSDKService extends Service {
	run() {
		try {
			appboy.initialize("5eb5b3c2-8331-47b3-9248-457fd5452502", {
				baseUrl: "https://sdk.iad-01.braze.com"
			});
			appboy.openSession();
		} catch (e) {
			console.log("Didnt init Braze SDK");
			console.log(e);
		}
	}
}
